import React from "react";

import { Tab } from "supercell-frontend-base/src/components/inbox/tab";

import { Article } from "supercell-frontend-base/src/components/article";

import styles from "./styles.modules.scss";
import { GameParams } from "supercell-frontend-base/src/validation/game-params";

type ArticleData = {
    articles: InboxArticle[];
    globals: Record<string, string>;
};

type ArticleViewProps = {
    id: string;
    getProps: (data: ArticleData) => {
        article: InboxArticle | undefined;
        Link: typeof import("supercell-frontend-base/src/components/article/navigation/link").Link;
        prevLinkProps?: Record<string, unknown>;
        nextLinkProps?: Record<string, unknown>;
    };
    track: (article: InboxArticle | undefined) => void;
};

type TabChildProps = {
    locale: LocaleSettings;
    data: GameData;
    userSettings: GameParams;
};

export const ArticleView = ({ id, getProps, track }: ArticleViewProps) => (
    <div className={`article ${styles.article}`}>
        <Tab namespace="news" id={id}>
            {(props: TabChildProps) => {
                const data = props.data as ArticleData;
                const { article, Link, prevLinkProps, nextLinkProps } =
                    getProps({
                        articles: data.articles,
                        globals: data.globals,
                    });

                track(article);

                if (!article) {
                    return <></>;
                }

                return (
                    <Article
                        article={article}
                        Link={Link}
                        nextLinkProps={nextLinkProps}
                        prevLinkProps={prevLinkProps}
                    />
                );
            }}
        </Tab>
    </div>
);
